import { isWorkspaceV2Path } from './workspaceV2';

export const taskNotificationRoute = (notification, route) => {
  if (notification.primary_actor_type !== 'Task') return null;
  const prefix = isWorkspaceV2Path(route.path) ? 'v2/tasks' : 'tasks';
  return {
    path: `/app/accounts/${route.params.accountId}/${prefix}`,
    query: { open: String(notification.primary_actor_id) },
  };
};
